import { PlusOutlined } from "@ant-design/icons";
import Button, { ButtonProps } from "../button";

export type AddButtonProps = ButtonProps;

export function AddButton(props: AddButtonProps) {
  return <Button type="primary" accent icon={<PlusOutlined />} {...props} />;
}
